// extracted by mini-css-extract-plugin
export default {"tilePlaceholder":"TilePlaceholder-module__tilePlaceholder--WiwAP"};